(function () {
  const DESKTOP_MQ = window.matchMedia("(min-width: 1100px)");
  const SLIDE_MS = 350;

  const initAsideMenu = () => {
    const asideMenu = document.querySelector(".aside-menu");
    if (!asideMenu || asideMenu.dataset.asideMenuInit === "true") return;
    asideMenu.dataset.asideMenuInit = "true";

    const header = document.querySelector(".header-wrapper");
    const openAsideMenuBtn = document.querySelector(".aside-menu__toggle--open-btn");
    const closeAsideMenuBtn = asideMenu.querySelector(".aside-menu__header-action--close");
    const mobileBackBtn = asideMenu.querySelector(".aside-menu__header-action--back");
    const mobileViews = asideMenu.querySelectorAll(".aside-menu__mobile-view");
    const tabs = asideMenu.querySelectorAll(".aside-menu__desktop .aside-menu__tab[role='tab']");
    const panels = asideMenu.querySelectorAll(".aside-menu__desktop .aside-menu__panel");

    let mobileStack = ["root"];
    let isAnimating = false;

    const isMobile = () => !DESKTOP_MQ.matches;

    const getMobileView = (viewId) =>
      asideMenu.querySelector(
        `.aside-menu__mobile-view[data-view-id="${viewId}"], .aside-menu__mobile-view[data-mobile-view="${viewId}"]`
      );

    const setActiveTab = (tabId) => {
      if (!DESKTOP_MQ.matches) return;

      tabs.forEach((tab) => {
        const isActive = tab.dataset.tabId === tabId;
        tab.classList.toggle("aside-menu__tab--active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
      });

      panels.forEach((panel) => {
        const isActive = panel.dataset.blockId === tabId;
        panel.classList.toggle("aside-menu__panel--active", isActive);
        if (isActive) {
          panel.removeAttribute("hidden");
        } else {
          panel.setAttribute("hidden", "");
        }
      });
    };

    const resetTabs = () => {
      const firstTab = tabs[0];
      if (firstTab?.dataset.tabId) {
        setActiveTab(firstTab.dataset.tabId);
      }
    };

    const updateMobileState = () => {
      const onRoot = mobileStack.length <= 1;
      asideMenu.classList.toggle("aside-menu--mobile-subview", isMobile() && !onRoot);
      asideMenu.classList.toggle("aside-menu--mobile-root", isMobile() && onRoot);
    };

    const resetMobileNav = () => {
      mobileStack = ["root"];
      isAnimating = false;

      mobileViews.forEach((view) => {
        view.classList.remove(
          "is-current",
          "is-previous",
          "is-entering-from-right",
          "is-entering-from-left",
          "is-exiting-to-left",
          "is-exiting-to-right"
        );
      });

      const rootView = getMobileView("root");
      if (rootView) {
        rootView.classList.add("is-current");
      }

      updateMobileState();
    };

    const animateMobileTo = (targetId) => {
      if (isAnimating || !targetId) return;

      const currentId = mobileStack[mobileStack.length - 1];
      if (currentId === targetId) return;

      const currentView = getMobileView(currentId);
      const targetView = getMobileView(targetId);
      if (!currentView || !targetView) return;

      isAnimating = true;

      currentView.classList.remove("is-current");
      currentView.classList.add("is-exiting-to-left");

      targetView.classList.add("is-entering-from-right");

      requestAnimationFrame(() => {
        targetView.classList.add("is-current");
        targetView.classList.remove("is-entering-from-right");
      });

      window.setTimeout(() => {
        currentView.classList.remove("is-exiting-to-left", "is-previous");
        currentView.classList.add("is-previous");
        isAnimating = false;
      }, SLIDE_MS);

      mobileStack.push(targetId);
      updateMobileState();
    };

    const mobileBack = () => {
      if (isAnimating || mobileStack.length <= 1) return;

      const currentId = mobileStack.pop();
      const targetId = mobileStack[mobileStack.length - 1];
      const currentView = getMobileView(currentId);
      const targetView = getMobileView(targetId);
      if (!currentView || !targetView) return;

      isAnimating = true;

      currentView.classList.remove("is-current", "is-previous");
      currentView.classList.add("is-exiting-to-right");

      targetView.classList.remove("is-previous");
      targetView.classList.add("is-entering-from-left", "is-current");

      requestAnimationFrame(() => {
        targetView.classList.remove("is-entering-from-left");
      });

      window.setTimeout(() => {
        currentView.classList.remove("is-exiting-to-right");
        isAnimating = false;
      }, SLIDE_MS);

      updateMobileState();
    };

    const openAsideMenu = (e) => {
      e.preventDefault();
      if (header) header.preventHide = true;
      asideMenu.classList.add("aside-menu--open");
      document.body.classList.add("overflow-hidden-drawer");
      resetTabs();
      resetMobileNav();
    };

    const closeAsideMenu = (e) => {
      if (e) e.preventDefault();
      asideMenu.classList.remove("aside-menu--open");
      document.body.classList.remove("overflow-hidden-drawer");
      if (header) header.preventHide = false;
      resetMobileNav();
    };

    if (openAsideMenuBtn) {
      openAsideMenuBtn.addEventListener("click", openAsideMenu);
    }

    if (closeAsideMenuBtn) {
      closeAsideMenuBtn.addEventListener("click", closeAsideMenu);
    }

    if (mobileBackBtn) {
      mobileBackBtn.addEventListener("click", (e) => {
        e.preventDefault();
        mobileBack();
      });
    }

    asideMenu.querySelectorAll("[data-mobile-go]").forEach((btn) => {
      btn.addEventListener("click", () => {
        if (!isMobile() || isAnimating) return;
        const targetId = btn.dataset.target;
        if (targetId) {
          animateMobileTo(targetId);
        }
      });
    });

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        if (tab.dataset.tabId) {
          setActiveTab(tab.dataset.tabId);
        }
      });
    });

    asideMenu.addEventListener("keydown", (e) => {
      if (e.code === "Escape") {
        if (isMobile() && mobileStack.length > 1) {
          mobileBack();
        } else {
          closeAsideMenu(e);
        }
      }
    });

    document.addEventListener("shopify:block:select", (event) => {
      if (!asideMenu.contains(event.target)) return;
      const blockId = event.detail?.blockId;
      if (blockId && DESKTOP_MQ.matches) {
        setActiveTab(blockId);
      }
    });

    DESKTOP_MQ.addEventListener("change", () => {
      resetMobileNav();
    });

    resetMobileNav();
    if (header) header.preventHide = false;
  };

  document.addEventListener("shopify:section:load", initAsideMenu);
  document.addEventListener("shopify:section:unload", () => {
    const asideMenu = document.querySelector(".aside-menu");
    if (asideMenu) delete asideMenu.dataset.asideMenuInit;
    initAsideMenu();
  });
  document.addEventListener("shopify:section:reorder", () => {
    const asideMenu = document.querySelector(".aside-menu");
    if (asideMenu) delete asideMenu.dataset.asideMenuInit;
    initAsideMenu();
  });

  initAsideMenu();
})();
